import React, { useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import GwDraggable from "../draggable";
import type { GwDraggableHelpProps } from "./dto";
import RightPng from "./right.png";
import { ReactComponent as FileSvg } from "./file.svg";

const getTopBound = (
  size: string = document.documentElement.style.fontSize
) => {
  return -window.innerHeight + (23.5 * parseFloat(size) || 16);
};

/** 默认拖拽边界 */
const DEFAULT_BOUNDS: GwDraggableHelpProps["bounds"] = "parent";

/** 默认显示文字 */
const DEFAULT_TEXT = "使用帮助";

/** 可拖拽帮助文档入口 */
const GwDraggableHelp = (props: GwDraggableHelpProps) => {
  const {
    href,
    show = true,
    disabled = false,
    axis = "y",
    bounds,
    text = DEFAULT_TEXT,
    defaultClassNameDragging = "wbuc-help-dragging",
    className,
    style,
    ...restProps
  } = props;

  const dragging = useRef(false);
  const divRef = useRef<HTMLDivElement>();

  const [innerBounce, setInnerBounce] = useState<
    GwDraggableHelpProps["bounds"]
  >({ top: getTopBound(), bottom: 0 });

  /** 如果组件禁用，组织Link的跳转 */
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();
    if (disabled) {
      e.preventDefault();
    }
    //拖动过程中组织默认时间
    if (dragging.current) {
      e.preventDefault();
    }
  };

  /** 内部拦截是否显示状态 */
  const visible = useMemo(() => {
    return show;
  }, [show]);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style"
        ) {
          const computedStyle = window.getComputedStyle(
            document.documentElement
          );
          const fontSize = computedStyle.getPropertyValue("font-size");
          const newTop = getTopBound(fontSize);
          setInnerBounce({ top: newTop, bottom: 0 });
        }
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <GwDraggable
      axis={axis}
      disabled={disabled}
      bounds={bounds || innerBounce || DEFAULT_BOUNDS}
      defaultClassNameDragging={defaultClassNameDragging}
      // onDrag={() => {
      //   divRef.current.classList.add("paused");
      // }}
      // onStop={() => divRef.current.classList.remove("paused")}
      {...restProps}
    >
      <div
        ref={divRef}
        style={{ ...style }}
        className={cn("wbuc-help-draggable", {
          ["wbuc-help-disabled"]: disabled,
          className: !!className,
        })}
      >
        <FileSvg className="wbuc-help-icon" />
        <div className="wbuc-help-row">
          <a
            href={href}
            onClick={handleClick}
            target="_blank"
            draggable={false}
            className={cn("wbuc-help-text1", {
              ["wbuc-help-disabled"]: disabled,
            })}
          >
            {text}
          </a>
          <a
            href={href}
            onClick={handleClick}
            target="_blank"
            draggable={false}
            className={cn("wbuc-help-text2", {
              ["wbuc-help-disabled"]: disabled,
            })}
          >
            {text}
          </a>
          <img alt="" src={RightPng} className="wbuc-help-arrow" />
        </div>
      </div>
    </GwDraggable>
  );
};

export default GwDraggableHelp;
